import React, { useEffect } from 'react';
import { getTranslations, setTranslations, translate } from './i18n';
export const I18nContext = React.createContext({
    messages: getTranslations(),
    translate
});
export const I18nContextHolder = ({ children, messages }) => {
    useEffect(() => {
        setTranslations(messages);
    }, [messages]);
    return (<I18nContext.Provider value={{ messages, translate }}>
      {children}
    </I18nContext.Provider>);
};
